// extracted by mini-css-extract-plugin
export default {"floating-save-button":"saveButton_floating-save-button__kN+-Q"};